import React from "react";

const Field = (props) => {
  return (
    <div className="field-section">
      <input
        required
        name={props.name}
        placeholder={props.placeholder}
        value={props.value}
        onChange={props.onChange}
        className={`field-type ${props.className} ${
          props.errorMessage ? "border border-danger" : ""
        } ${props.name ? "border border-0" : "border border-danger"}`}
        type={props.type}
        style={props.style}></input>
    </div>
  );
};

export default Field;
